import { useSavedFiltersStatus } from '@/features/analyze/hooks/useSavedFiltersStatus';
import { graphql, useQuery } from '@/lib/graphql';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { SavedFilterItem } from './SavedFilterItem';
import { SavedFiltersCount } from './SavedFiltersCount';

const getSavedFiltersQuery = graphql(
  `
    query getSavedFilters {
      savedFilters {
        id
        ...SavedFilterItemFragment
      }
    }
  `,
  [SavedFilterItem.fragments.data]
);

const savedFiltersListFragment = graphql(
  `
    fragment SavedFiltersListFragment on Query {
      savedFilters {
        ...SavedFilterItemFragment
      }
    }
  `,
  [SavedFilterItem.fragments.data]
);

type SavedFiltersListProps = {
  className?: string;
};

export const SavedFiltersList = ({ className }: SavedFiltersListProps) => {
  const { t } = useTranslation();
  const { data, loading, error } = useQuery(getSavedFiltersQuery);
  const savedFilters = data?.savedFilters || [];

  const {
    count: savedFiltersCount,
    max: savedFiltersMax,
    loading: isLoadingSavedFilters,
  } = useSavedFiltersStatus();

  return (
    <div
      className={clsx(
        'rounded-tr-2xl bg-rw-white text-rw-dark-gray',
        className
      )}
    >
      <div className="mb-2 flex items-center justify-between">
        <div className="text-lg font-medium">{t('保存されたフィルタ')}</div>
        <SavedFiltersCount
          count={savedFiltersCount}
          max={savedFiltersMax}
          loading={isLoadingSavedFilters}
        />
      </div>

      <hr className="my-0.5 h-[2px] bg-rw-light-gray" />

      <div className="mt-2 space-y-1">
        {error && (
          <div className="p-2.5 text-sm text-red-500">
            {t('保存されたフィルタの読み込みに失敗しました')}
          </div>
        )}

        {!loading && savedFilters.length === 0 ? (
          <div className="p-2.5 text-sm text-gray-500">
            {t('保存されたフィルタはありません')}
          </div>
        ) : (
          savedFilters.map((filter) => (
            <SavedFilterItem
              key={filter.id}
              data={filter}
              className="px-2.5 py-1"
            />
          ))
        )}
      </div>
    </div>
  );
};

SavedFiltersList.fragments = {
  data: savedFiltersListFragment,
};
